import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Wrapper from "../Components/Common/Wrapper";
import Dashboard from "../Components/Dashboard/Dashboard";
import Sales from "../Components/Orders";
import Order from "../Components/Orders/Order";
import NewOrder from "../Components/Orders/Order/NewOrder";
import "focus-visible/dist/focus-visible";
import Products from "../Components/Products";
import Suppliers from "../Components/Suppliers";
import Supplier from "../Components/Suppliers/Supplier";
import Product from "../Components/Products/Product";
import Purchase from "../Components/Purchases/Purchase";
import NewPurchase from "../Components/Purchases/Purchase/NewPurchase";
import Purchases from "../Components/Purchases";
import PriceLists from "../Components/PriceLists";
import PriceList from "../Components/PriceLists/PriceList";
import Sellers from "../Components/Users/Sellers";
import User from "../Components/Users/User";
import Clients from "../Components/Users/Clients";
import Operators from "../Components/Users/Operators";
import NewPriceList from "../Components/PriceLists/PriceList/NewPriceList";
import PrivatesRoute from "./PrivatesRoute";
import Login from "../Components/Login";
import Zones from "../Components/Users/Zones";
import Bill from "../Components/Orders/Order/Bill";
import LoginRoutes from "./LoginRoute";
import Categries from "../Components/Products/categories";
import Billing from "../Components/Reports/Billing";
import ProductsReport from "../Components/Reports/Products";
import PurchaseReport from "../Components/Reports/Purchases";
import StockReport from "../Components/Reports/Stock";
import MinStockReport from "../Components/Reports/MinStock";
import AccessControl from "../Components/AccessControl";

const index = () => {
  return (
    <Router>
      <Switch>
        <LoginRoutes exact path="/login" component={Login}></LoginRoutes>
        <PrivatesRoute
          minRole={2}
          path="/pedidos/:id/facturas"
          component={Bill}
        ></PrivatesRoute>
        <Route path="/">
          <Wrapper>
            <PrivatesRoute
              minRole={2}
              exact
              path="/"
              component={Dashboard}
            ></PrivatesRoute>
            <PrivatesRoute
              minRole={2}
              path="/pedidos/lista/:state"
              component={Sales}
            ></PrivatesRoute>
            <PrivatesRoute
              minRole={2}
              actionsIdAllowed={[11]}
              path="/pedidos/nuevo"
              component={NewOrder}
            ></PrivatesRoute>
            <PrivatesRoute
              minRole={2}
              exact
              path="/pedidos/:id"
              component={Order}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              path="/pedidos"
              component={Sales}
            ></PrivatesRoute>
            <PrivatesRoute
              path="/articulos/:id"
              minRole={2}
              actionsIdAllowed={[1]}
              component={Product}
            ></PrivatesRoute>
            <PrivatesRoute
              path="/categorias"
              minRole={2}
              component={Categries}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              path="/articulos"
              component={Products}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              path="/compras"
              component={Purchases}
            ></PrivatesRoute>
            <PrivatesRoute
              minRole={2}
              path="/compras/nueva"
              actionsIdAllowed={[13]}
              component={NewPurchase}
            ></PrivatesRoute>
            <PrivatesRoute
              minRole={2}
              exact
              path="/compras/:id"
              component={Purchase}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              path="/proveedores"
              component={Suppliers}
            ></PrivatesRoute>
            <PrivatesRoute
              minRole={2}
              path="/proveedores/:id"
              component={Supplier}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              path="/lista-de-precios"
              component={PriceLists}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              path="/lista-de-precios/new"
              component={NewPriceList}
            ></PrivatesRoute>
            <PrivatesRoute
              minRole={2}
              path="/lista-de-precios/:id"
              component={PriceList}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              path="/vendedores"
              component={Sellers}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              path="/clientes"
              component={Clients}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              path="/usuarios/:id"
              component={User}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={1}
              path="/operadores"
              component={Operators}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              path="/usuarios/nuevo"
              component={User}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              path="/usuarios/zonas"
              component={Zones}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              actionsIdAllowed={[8]}
              path="/reportes/facturacion"
              component={Billing}
            ></PrivatesRoute>{" "}
            <PrivatesRoute
              exact
              minRole={2}
              actionsIdAllowed={[8]}
              path="/reportes/articulos"
              component={ProductsReport}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              actionsIdAllowed={[8]}
              path="/reportes/compras"
              component={PurchaseReport}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              actionsIdAllowed={[8]}
              path="/reportes/stock-valorizado"
              component={StockReport}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={2}
              actionsIdAllowed={[8, 9]}
              path="/reportes/stock-minimo"
              component={MinStockReport}
            ></PrivatesRoute>
            <PrivatesRoute
              exact
              minRole={1}
              path="/permisos"
              component={AccessControl}
            ></PrivatesRoute>
          </Wrapper>
        </Route>
      </Switch>
    </Router>
  );
};

export default index;
